module.exports = __webpack_public_path__ + "static/media/Rectangle 117.a8fe221b.png";